import { StackedTextImageForm as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { StackedTextImageFormProps } from '.';

const TestData: StackedTextImageFormProps = {
  header: "Let's talk.",
  richText: 'The more we know about you and what you want, the closer we are to finding it.',
  imgFocalPoint: {
    image: '/assets/test.png',
  },
  ctaText: 'Send Message',
  chimeId: '0',
  chimeType: 'shop',
  disclaimer:
    'By checking this box, you agree that Engel & Völkers, its affiliates or associated third parties may contact you, including with calls or texts by automated means. You also agree to our Terms of Service and Privacy Policy. Message/data rates may apply. Consent is not a condition to access real estate services.',
  eyebrow: 'Our Commitment',
  reverse: false,
};

export default fakeProps(schema, TestData);
